<template>
    <v-card>
        <v-toolbar color="white">
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn flat @click.native="close(false)">zavřít</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-container :style="'height: ' + containerHeight">
            <youtube @ready="ready" video-id="_-85kfWO-0E" player-width="100%" :player-height="playerHeight" :player-vars="playerVars"></youtube>
        </v-container>
    </v-card>
</template>

<script>

  export default {
    data () {
      return {
        player: '',
        playerVars: { start: 0 }
      }
    },
      created () {
          this.$root.$on('youtube', () => {
              this.player.playVideo();
          });
      },
    computed: {
        containerHeight () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return '250px'
                case 'sm': return '500px'
                case 'md': return '800px'
                case 'lg': return '800px'
                case 'xl': return '800px'
            }
        },
        playerHeight() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return '200px'
                case 'sm': return '400px'
                case 'md': return '700px'
                case 'lg': return '700px'
                case 'xl': return '700px'
            }
        }
    },
    methods: {
      ready (event) {
        this.player = event.target;
      },
      close(update) {
        this.player.stopVideo();
        this.$emit('closed', {update: update, type: 'youtube'});
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/modals/YoutubeModal.vue